import { render, staticRenderFns } from "./IntegraImovelWeb.vue?vue&type=template&id=507c50c6"
import script from "./IntegraImovelWeb.vue?vue&type=script&lang=js"
export * from "./IntegraImovelWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports